import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import AppProviders from './AppProviders';
import { initAnalytics } from './lib/analytics';
import '../styles/index.css';

// Initialize PostHog BEFORE the first render so the `$pageview` for
// the landing route fires. Safe to call on every host — the function
// short-circuits on non-prod hostnames (localhost, dev.*) so there's
// no event noise from local development.
initAnalytics();

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(
        <React.StrictMode>
            <AppProviders>
                <App />
            </AppProviders>
        </React.StrictMode>
    );
}
